import React from "react";
import { formatLocationPair } from "../../../components/helper/helper";

// Renders the "Multi-Merchant" / "Additional Location" read-only rows shared
// by the business profile detail screens. Caller is responsible for the
// is_multiple_locations check and any wrapping element.
function MultiLocationDetailRows({
  multiMerchant,
  multiMerchantOf,
  additionalLocation,
  additionalLocationOf,
  itemClassName,
  labelClassName,
  valueClassName,
}) {
  return (
    <>
      <div className={itemClassName}>
        <div className={labelClassName}>Multi-Merchant</div>
        <div className={valueClassName}>
          {formatLocationPair(multiMerchant, multiMerchantOf)}
        </div>
      </div>
      <div className={itemClassName}>
        <div className={labelClassName}>Additional Location</div>
        <div className={valueClassName}>
          {formatLocationPair(additionalLocation, additionalLocationOf)}
        </div>
      </div>
    </>
  );
}

export default MultiLocationDetailRows;
